import React from 'react'
import { Link } from 'react-router-dom'
import Blog_1 from '../../../assets/images/home_page_4/blog/03.png'
import Blog_2 from '../../../assets/images/home_page_4/blog/01.png'
import Blog_3 from '../../../assets/images/home_page_4/blog/04.png'
import Blog_4 from '../../../assets/images/home_page_4/blog/09.png'
import Blog_5 from '../../../assets/images/home_page_4/blog/10.png'
import Blog_6 from '../../../assets/images/home_page_4/blog/05.png'
import Blog_7 from '../../../assets/images/home_page_4/blog/06.png'
import Blog_8 from '../../../assets/images/home_page_4/blog/07.png'
import Blog_9 from '../../../assets/images/home_page_4/blog/08.png'

const Blogdetails = () => {
    return (
        <>
            <section id="blog-details" className="blog-details-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-7">
                            <div className="blog-details-block">
                                <div className="blog-details-img">
                                    <img
                                        src={Blog_1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <span className="badge text-bg-primary">31 Oct,2025</span>
                                </div>
                                <div className="blog-details-dtls">
                                    <ul className="blog-tags">
                                        <li>
                                            <i className="flaticon-avatar" /> By admin
                                        </li>
                                        <li>
                                            <i className="flaticon-offer" /> Category
                                        </li>
                                        <li>
                                            <i className="flaticon-comment-1" /> Comments (05)
                                        </li>
                                    </ul>
                                    <h2 className="blog-heading">Marketing for the digital age</h2>
                                    <p>
                                        Web designing in a powerful way of just not an only professions,
                                        however, in a passion for our Company. We have to a tendency to
                                        believe the idea that smart looking of any website is the first
                                        impression on visitors.Web designing in a powerful way of just not
                                        an only professions, however, in a passion for our Company. We
                                        have
                                    </p>
                                    <p>
                                        Web designing in a powerful way of just not an only professions,
                                        however, in a passion for our Company. We have to a tendency to
                                        believe the idea that smart looking of any website is the first
                                        impression on visitors.Web designing in a powerful way of just not
                                        an only professions, however, in a passion for our Company. We
                                        have to a tendency to believe the idea that smart looking of any
                                        website is the first impression on visitors.Web designing in a
                                        powerful way of just not an only professions, however, in a
                                        passion for our Company. We have to a tendency to believe the idea
                                        that smart looking of any website is the first impression on
                                        visitors.
                                    </p>
                                </div>
                                <div className="blog-features-block">
                                    <h2 className="blog-feature-title">Our Features</h2>
                                    <ul className="blog-features-list">
                                        <li>
                                            <i className="flaticon-dot" /> Decimals, Fractions and
                                            Percentages
                                        </li>
                                        <li>
                                            <i className="flaticon-dot" /> Miss Courtney Henry
                                        </li>
                                        <li>
                                            <i className="flaticon-dot" /> Exam Skills
                                        </li>
                                        <li>
                                            <i className="flaticon-dot" /> Explain variation
                                        </li>
                                        <li>
                                            <i className="flaticon-dot" /> HCF and LCM using product of
                                            primes
                                        </li>
                                    </ul>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6">
                                        <div className="blog-dtls-img">
                                            <img
                                                src={Blog_2}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="blog-dtls-img">
                                            <img
                                                src={Blog_3}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                </div>
                                <blockquote className="blockquote">
                                    <p>
                                        Lorem Ipsum is simply dummy text of the printing and typesetting
                                        industry. Lorem Ipsum has been the industry's standard dummy text
                                        ever since the 1500s, when an unknown printer took a galley of
                                        type and scrambled
                                    </p>
                                    <img
                                        src={Blog_4}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </blockquote>
                                <p>
                                    Web designing in a powerful way of just not an only professions,
                                    however, in a passion for our Company. We have to a tendency to
                                    believe the idea that smart looking of any website is the first
                                    impression on visitors.Web designing in a powerful way of just not
                                    an only professions, however, in a passion for our Company. We have
                                    to a tendency to believe the idea that smart looking of any website
                                    is the first impression on visitors.
                                </p>
                            </div>
                            <div className="blog-tags-share-block">
                                <div className="row">
                                    <div className="col-lg-10 col-md-8">
                                        <h3 className="blog-category-heading">Popular Tags:</h3>
                                        <div className="blog-popular-block">
                                            <ul>
                                                <li>
                                                    <Link to="#" title="">
                                                        Facilities
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="">
                                                        Children
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="">
                                                        Policy
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="">
                                                        Medical
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" title="">
                                                        Education
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-md-4">
                                        <h3 className="blog-category-heading">Share:</h3>
                                        <ul className="blog-share-block">
                                            <li>
                                                <i className="flaticon-facebook" />
                                            </li>
                                            <li>
                                                <i className="flaticon-twitter" />
                                            </li>
                                            <li>
                                                <i className="flaticon-linkedin" />
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="blog-comment-block">
                                <h3 className="blog-comment-title">3 Comment</h3>
                                <div className="comment-block">
                                    <div className="comment-img">
                                        <img
                                            src={Blog_5}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </div>
                                    <div className="comment-dtl">
                                        <div className="row">
                                            <div className="col-lg-8 col-md-8">
                                                <h3 className="comment-name">Mike Dooley</h3>
                                                <p>October 31,2025 at 8:50 P.M</p>
                                            </div>
                                            <div className="col-lg-4 col-md-4 text-start text-lg-end">
                                                <Link to="#" title="" className="btn btn-primary">
                                                    Reply
                                                </Link>
                                            </div>
                                        </div>
                                        <p>
                                            Contrary to popular belief, Lorem Ipsum is not simply random
                                            text. It has roots in a piece of classical Latin literature from
                                            45 BC, making it over 2000 years old. RichardClintock
                                        </p>
                                    </div>
                                </div>
                                <div className="comment-block comment-block-one">
                                    <div className="comment-img">
                                        <img
                                            src={Blog_5}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </div>
                                    <div className="comment-dtl">
                                        <div className="row">
                                            <div className="col-lg-8 col-md-8">
                                                <h3 className="comment-name">Mike Dooley</h3>
                                                <p>October 31,2025 at 8:50 P.M</p>
                                            </div>
                                            <div className="col-lg-4 col-md-4 text-start text-lg-end">
                                                <Link to="#" title="" className="btn btn-primary">
                                                    Reply
                                                </Link>
                                            </div>
                                        </div>
                                        <p>
                                            Contrary to popular belief, Lorem Ipsum is not simply random
                                            text. It has roots in a piece of classical Latin literature from
                                            45 BC, making it over 2000 years old. RichardClintock
                                        </p>
                                    </div>
                                </div>
                                <div className="comment-block">
                                    <div className="comment-img">
                                        <img
                                            src={Blog_5}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </div>
                                    <div className="comment-dtl">
                                        <div className="row">
                                            <div className="col-lg-8 col-md-8">
                                                <h3 className="comment-name">Mike Dooley</h3>
                                                <p>October 31,2025 at 8:50 P.M</p>
                                            </div>
                                            <div className="col-lg-4 col-md-4 text-start text-lg-end">
                                                <Link to="#" title="" className="btn btn-primary">
                                                    Reply
                                                </Link>
                                            </div>
                                        </div>
                                        <p>
                                            Contrary to popular belief, Lorem Ipsum is not simply random
                                            text. It has roots in a piece of classical Latin literature from
                                            45 BC, making it over 2000 years old. RichardClintock
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="blog-reply-block">
                                <h3 className="blog-comment-title">Leave a Reply</h3>
                                <form>
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-floating">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="floatingName"
                                                    placeholder="Your Name"
                                                />
                                                <label htmlFor="floatingName">Your Name</label>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-floating">
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    id="floatingEmail"
                                                    placeholder="Your Email"
                                                />
                                                <label htmlFor="floatingEmail">Your Email</label>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-floating">
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    id="floatingPhone"
                                                    placeholder="Phone Number"
                                                />
                                                <label htmlFor="floatingPhone">Phone Number</label>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-floating">
                                                <select
                                                    className="form-select"
                                                    id="floatingSelect"
                                                    aria-label="Floating label select example"
                                                >
                                                    <option selected="">Choose a Option</option>
                                                    <option value={1}>One</option>
                                                    <option value={2}>Two</option>
                                                    <option value={3}>Three</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="form-floating">
                                                <textarea
                                                    className="form-control"
                                                    placeholder="Leave a comment here"
                                                    id="floatingTextarea2"
                                                    defaultValue={""}
                                                />
                                                <label htmlFor="floatingTextarea2">Message here...</label>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="submit" className="btn btn-primary">
                                        Submit Now <i className="flaticon-right-arrow-1" />
                                    </button>
                                </form>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-5">
                            <div className="blog-category-block">
                                <h3 className="blog-category-heading">Category</h3>
                                <ul>
                                    <li>
                                        <Link to="#" title="">
                                            <i className="flaticon-folder" /> Ducimus Laborum Beatae
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#" title="">
                                            <i className="flaticon-folder" /> In omnis quos
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#" title="">
                                            <i className="flaticon-folder" /> Numquam ut enim
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#" title="">
                                            <i className="flaticon-folder" /> Pariatur quia eaque
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#" title="">
                                            <i className="flaticon-folder" /> Reprehenderit repellendus sunt
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="blog-category-block">
                                <h3 className="blog-category-heading">Recent Posts</h3>
                                <div className="blog-post-block">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-4 col-4">
                                            <div className="blog-post-img">
                                                <Link to="/BlogDetails" title="">
                                                    <img
                                                        src={Blog_6}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="col-lg-8 col-md-8 col-8">
                                            <div className="blog-post-dtls">
                                                <h3 className="blog-post-title">
                                                    <Link to="/BlogDetails" title="">
                                                        Principle stability in the future with activity
                                                    </Link>
                                                </h3>
                                                <p>
                                                    <i className="flaticon-calendar" /> 20 Aug,2022
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="blog-post-block">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-4 col-4">
                                            <div className="blog-post-img">
                                                <Link to="/BlogDetails" title="">
                                                    <img
                                                        src={Blog_7}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="col-lg-8 col-md-8 col-8">
                                            <div className="blog-post-dtls">
                                                <h3 className="blog-post-title">
                                                    <Link to="/BlogDetails" title="">
                                                        How to invent a law &amp; pass it in parliament
                                                    </Link>
                                                </h3>
                                                <p>
                                                    <i className="flaticon-calendar" /> 20 Aug,2022
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="blog-post-block">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-4 col-4">
                                            <div className="blog-post-img">
                                                <Link to="/BlogDetails" title="">
                                                    <img
                                                        src={Blog_8}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="col-lg-8 col-md-8 col-8">
                                            <div className="blog-post-dtls">
                                                <h3 className="blog-post-title">
                                                    <Link to="/BlogDetails" title="">
                                                        Principle stability in the future with activity
                                                    </Link>
                                                </h3>
                                                <p>
                                                    <i className="flaticon-calendar" /> 20 Aug,2022
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="blog-post-block">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-4 col-4">
                                            <div className="blog-post-img">
                                                <Link to="/BlogDetails" title="">
                                                    <img
                                                        src={Blog_9}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="col-lg-8 col-md-8 col-8">
                                            <div className="blog-post-dtls">
                                                <h3 className="blog-post-title">
                                                    <Link to="/BlogDetails" title="">
                                                        How to invent a law &amp; pass it in parliament
                                                    </Link>
                                                </h3>
                                                <p>
                                                    <i className="flaticon-calendar" /> 20 Aug,2022
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="blog-category-block">
                                <h3 className="blog-category-heading">Popular Tags</h3>
                                <div className="blog-popular-block">
                                    <ul>
                                        <li>
                                            <Link to="#" title="">
                                                Facilities
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" title="">
                                                Children
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" title="">
                                                Policy
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" title="">
                                                Vote
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" title="">
                                                Medical
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" title="">
                                                Education
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" title="">
                                                Meeting
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Blogdetails
